import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('/php/send_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData)
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', phone: '', email: '', message: '' });
        setTimeout(() => setStatus(''), 3000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div 
        className="bg-opacity-100 text-black p-4 md:p-6 rounded-xl shadow-2xl transition-all duration-300 ease-in-out hover:bg-opacity-90 hover:transform hover:scale-105 hover:shadow-3xl"
      >
        {/* Header */}
        <div className="bg-primary text-white text-center p-3 md:p-4 rounded-lg mb-3 md:mb-4 opacity-90">
          <h2 className="text-lg md:text-xl uppercase font-bold">Få Et Uforpligtende Tilbud</h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-2 md:space-y-3">
          <div className="form-group">
            <input
              type="text"
              id="form-name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Navn"
              required
              className="w-full px-3 py-2 md:px-4 md:py-2.5 border-2 border-transparent rounded-lg text-sm md:text-base transition-all duration-300 bg-white text-black placeholder-gray-600 focus:border-white focus:bg-white focus:bg-opacity-30 focus:outline-none"
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              id="form-phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Telefon"
              required
              pattern="[0-9()#&+*\-=.]+"
              title="Kun tal og telefonkarakterer (#,-,*, o.s.v.) accepteres."
              className="w-full px-3 py-2 md:px-4 md:py-2.5 border-2 border-transparent rounded-lg text-sm md:text-base transition-all duration-300 bg-white text-black placeholder-gray-600 focus:border-white focus:bg-white focus:bg-opacity-30 focus:outline-none"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              id="form-email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="E-mail"
              required
              className="w-full px-3 py-2 md:px-4 md:py-2.5 border-2 border-transparent rounded-lg text-sm md:text-base transition-all duration-300 bg-white text-black placeholder-gray-600 focus:border-white focus:bg-white focus:bg-opacity-30 focus:outline-none"
            />
          </div>

          <div className="form-group">
            <textarea
              id="form-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              placeholder="Skriv din besked"
              required
              className="w-full px-3 py-2 md:px-4 md:py-2.5 border-2 border-transparent rounded-lg text-sm md:text-base transition-all duration-300 bg-white text-black placeholder-gray-600 focus:border-white focus:bg-white focus:bg-opacity-30 focus:outline-none resize-none"
            />
          </div>

          <div className="form-group">
            <button
              type="submit"
              disabled={status === 'sending'}
              className="w-full bg-black hover:bg-primary text-white font-bold py-2.5 md:py-3 px-4 md:px-6 rounded-lg text-base md:text-lg transition-all duration-300 ease-in-out transform hover:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'sending' ? 'Sender...' : 'Send'}
            </button>
          </div>

          {/* Status Messages */}
          {status === 'success' && (
            <div className="text-center text-green-600 text-sm md:text-base font-semibold bg-green-100 p-2 md:p-3 rounded-lg">
              Din besked er sendt! Vi kontakter dig snart.
            </div>
          )}
          {status === 'error' && (
            <div className="text-center text-red-600 text-sm md:text-base font-semibold bg-red-100 p-2 md:p-3 rounded-lg">
              Der skete en fejl. Prøv venligst igen.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;